import { HexagonListModel, StatusModel } from "src/app/model";

export interface ModuleHealthModel {
  series: HexagonListModel[];
  utilisation: StatusModel;
}

export interface ModuleHealthPayloadModel {
  deviceId: string;
  timeRange: {
    from: number;
    to: number;
  }
}